/** SentryKit 2.0 brand images — sidebar shield vs full wordmark elsewhere. */
module.exports = {
  /** White shield from 2.0 wordmark — for navy sidebar (#122E52). */
  logoShieldIcon: require('../assets/logo-shield-sidebar.png'),
  sentrykitWordmark: require('../assets/sentrykit-2-wordmark.png')
}



// WEBPACK FOOTER //
// ./src/utils/brandAssets.js